import domToImage from 'dom-to-image'

export function downloadHtmlNodeAsImage(element: Node | null, fileName = 'download') {
  if (element) {
    domToImage.toPng(element).then((dataUrl: string) => {
      const link = document.createElement('a')
      link.download = `${fileName}.png`
      link.href = dataUrl
      link.click()
    })
  }
}
